export const title = 'Principales enfermedades causadas por patógenos en la región';

export const featuresNotes = [
    {
        id: 1,
        name: 'Pythium',
        type: 'Oomycetees parásitos',
        moment: '',
        symptoms: [
            'Causa pudrición y ablandamiento de la semilla previo a germinación.',
            'Las plántulas infectadas pueden morir previamente o justo después de emergencia.',
            'Necrosamiento, lesiones viscosas en raíz o mesocótilo casusando marchitamiento y/o podredumbre de los tejidos externos, mientras que el tejido permanece intacto.',
        ],
        damage: [],
        cultives: 'Varios cultivos incluídos maíz, soja y algodón.',
        conditions: ['Es favorecida por suelos húmedos y fríos.'],
        control: 'Fungicida Metalaxyl',
        images: ['pathogen-1'],
        color: 'green',
        side: 'ltr',
    },
    {
        id: 2,
        name: 'Oomycetees',
        type: 'Oomycetees parásitos',
        moment: '',
        symptoms: ['Causa humedecimiento y ablandamiento de raíces, semillas y plántulas. Muy similar al Pythium.'],
        damage: [],
        cultives: 'Más común en el cultivo de soja.',
        conditions: [
            'Se desarrolla rápidamente cuando el suelo está con alta humedad y la tempreratura por arriba de 15ºC.',
            'Es común en áreas bajas, con poco drenaje, compactación y alto contenido de arcilla. Sin embargo se la puede encontrar incluso en áreas de loma y buen drenaje bajo condiciones de anegamiento.',
        ],
        control: 'Fungicidas Triazoles y Metalaxyl',
        images: ['pathogen-2'],
        color: 'light-green',
        side: 'rtl',
    },
    {
        id: 3,
        name: 'Rhizoctonia',
        type: 'Hongo',
        moment: '',
        symptoms: [
            'La infección en plántulas aparecen como secas, lesiones hundidas de color rojizo-marrón oscuro justo por encima de la línea del suelo. Raíces y tallos podridos son comunes.',
            'La planta se puede mostrar marchita.',
        ],
        damage: [],
        cultives: 'Varios cultivos incluidos maíz y soja',
        conditions: ['Favorecida por suelos cálidos entre 20 y 30°C y moderado contenido de humedad.'],
        control: 'Fungicidas Estrobirulinas',
        images: ['pathogen-3'],
        color: 'dark-green',
        side: 'ltr',
    },
    {
        id: 4,
        name: 'Fusarium',
        type: 'Hongo',
        moment: '',
        symptoms: [
            'Las raíces de plántulas infectadas aparecen con podredumbre y decoloración de marrón rojiza oscura a marrón claro. Puede asemejar Rhizoctonia.',
            'En el caso específico de maíz el mesocótilo puede estar marchito.',
        ],
        damage: [],
        cultives: 'Puede afectar varios cultivos incluyendo Soja y Maíz.',
        conditions: ['En temperaturas cálidas la planta puede presentar síntomas de marchitamiento.'],
        control: 'Fungicidas Triazoles',
        images: ['pathogen-4'],
        color: 'light-brown',
        side: 'rtl',
    },
    {
        id: 5,
        name: 'Penicillum',
        type: 'Hongo',
        moment: '',
        symptoms: [
            'La pudrición del mesocótilo y raíces , apreciándose un  crecimiento verde-azulado del hongo en semillas.',
            'Amarronamiento apical de las hojas.',
            'Achaparramiento, amarillamiento de plantas y finalmente muerte.',
        ],
        damage: [],
        cultives: 'Puede ser un problema potencial en Maíz, sorgo y otros cultivos.',
        conditions: ['Es favorecido por altas temperaturas.'],
        control: 'Fungicidas Triazoles',
        images: ['pathogen-5'],
        color: 'green',
        side: 'ltr',
    },
];
